import { createAppRequest } from '@/services/request';

const request = createAppRequest();

export interface OpenPlatformTokenResult {
  accessToken: string;
}

export async function getOpenPlatformToken(): Promise<OpenPlatformTokenResult | undefined> {
  try {
    return await request<OpenPlatformTokenResult>('/bff/open-platform/token', {
      method: 'GET',
      skipErrorHandler: true,
    });
  } catch {
    return undefined;
  }
}
